import { type RefObject, useCallback, useEffect, useState } from 'react'

import type { SelectedCategory } from '../../../types'
import type { InteractionState, SearchProps } from '../types'

type UseSearchProps = {
  search: SearchProps
  initialCategory: SelectedCategory
  interactionState: InteractionState
  inputRef: RefObject<HTMLInputElement>
}

export const useSearch = ({
  search,
  initialCategory,
  interactionState,
  inputRef,
}: UseSearchProps) => {
  const [isSearched, setIsSearched] = useState(false)
  const [inputValue, setInputValue] = useState(initialCategory?.name || '')

  useEffect(() => {
    if (interactionState === 'input' && !isSearched) {
      setInputValue(initialCategory?.name || '')
    }
  }, [initialCategory, interactionState, isSearched])

  useEffect(() => {
    if (interactionState === 'input') {
      setInputValue(initialCategory?.name || '')
      inputRef.current?.focus()
    }

    if (!interactionState) {
      resetSearch()
    }
  }, [interactionState, initialCategory])

  const handleSearchChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setIsSearched(true)
      search.onChange(e.target.value)
    },
    [search],
  )

  const resetSearch = useCallback(() => {
    search.onChange('')
    setIsSearched(false)
  }, [search])

  return {
    isSearched,
    inputValue,
    handleSearchChange,
    resetSearch,
  }
}
